export default "__VITE_ASSET__D19ep_yF__"